import React from "react";
import "./App.css";
import Header from'./components/Header';
import HeroSlider from "./components/HeroSlider";
import About from "./components/About";
import Categories from "./components/Categories";
import Stats from "./components/Stats";
import Products from "./components/Products";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App()
{
  return(
    <div className="app">
      <Header/>
      <HeroSlider/>
      <About/>
      <Stats/>
      <Products/>
      <Services/>
      <Categories/>
      <Gallery/>
      <Contact/>
      <Footer/>
    </div>
  );
}
export default App;